/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useQuery } from "@tanstack/react-query";
import { notificarErroApi } from "utils/alertaCiencia";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

export function useGetTiposSeries() {
  const GET_FICHA = `${backofficeEnviroment}/common/oportunidades-lead/tipos-series`;
  const fetchData = async () => {
    const response = await instance.get(GET_FICHA);
    return response?.data?.data;
  };
  const query = useQuery({
    queryFn: fetchData,
    queryKey: ["get-tipos-series"],
    refetchOnWindowFocus: false,
    enabled: true,
    onSuccess: () => {},
    onError: (error: any) => {
      notificarErroApi("Erro ao buscar Série", error);
    },
  });
  return query;
}
